enum AnnotationStampFunctionFields {
	CREATOR = "creator",
	SUBJECT = "subject",
	CONTENTS = "contents",
	INTENTS = "intents",
	OPACITY = "opacity",
	COLOR = "color",
	BORDER_COLOR = "border_color",
	FONT_COLOR = "font_color",
	FONT_SIZE = "font_size",
	TEXT = "text"
}

export default AnnotationStampFunctionFields;